/**
 * Mo ta nam loai captcha cho trang /playground.
 *
 * Bang nay la NGUON SU THAT DUY NHAT cua trang: no quyet dinh o nhap nao hien ra, giup
 * y nao duoc doc, va body nao duoc dung. Them mot loai captcha moi = them mot muc o day,
 * khong phai sua rai rac trong JSX — dung tinh chat 3 cua dac ta.
 */

export const NATIVE_TYPES = ['text', 'image', 'grid', 'rotate', 'pow'] as const;
export type NativeType = (typeof NATIVE_TYPES)[number];

export interface TypeInfo {
  id: NativeType;
  /** Ten hien tren the chon. */
  label: string;
  /** Task type tuong ung cua lop 2Captcha — nguoi dung can biet de doi chieu tai lieu. */
  taskType: string;
  solver: string;
  /** Mot cau: loai captcha nay la gi. */
  what: string;
  /** Can chuan bi gi truoc khi dung duoc. */
  needs: string;
  /** true = khong can model hay du lieu gi ca (van phai bat profile — trang tu nhac). */
  worksOutOfBox: boolean;
  input: 'text' | 'image' | 'pow';
}

export const TYPE_INFO: ReadonlyArray<TypeInfo> = [
  {
    id: 'text',
    label: 'Câu hỏi chữ',
    taskType: 'TextCaptchaTask',
    solver: 'text',
    what: 'Captcha dạng câu hỏi: "muoi cong nam bang may?", "XII + III", "ky tu thu 3 cua CAPFORGE".',
    needs: 'Không cần gì cả — chạy được ngay.',
    worksOutOfBox: true,
    input: 'text',
  },
  {
    id: 'pow',
    label: 'Proof of Work',
    taskType: 'CapforgePowTask',
    solver: 'pow',
    what: 'Altcha: tìm một con số mà băm ra đúng chuỗi challenge của server. Solver duy nhất TỰ CHỨNG MINH được mình đúng.',
    needs: 'Không cần model. Bấm nút bên dưới để sinh một challenge mẫu hợp lệ.',
    worksOutOfBox: true,
    input: 'pow',
  },
  {
    id: 'image',
    label: 'Chữ trong ảnh',
    taskType: 'ImageToTextTask',
    solver: 'ocr',
    what: 'Captcha chữ méo tự host: Securimage, PHP GD, MyBB, phpBB, KCAPTCHA…',
    needs: 'Cần một model ONNX đã kích hoạt. Xem trang Model.',
    worksOutOfBox: false,
    input: 'image',
  },
  {
    id: 'grid',
    label: 'Lưới ảnh',
    taskType: 'GridTask',
    solver: 'hashgrid',
    what: '"Chọn tất cả ô có xe hơi". Không nhận dạng gì cả — băm mỗi ô rồi tra bảng.',
    needs: 'Cần từ điển pHash đã dựng. Xem trang Captcha lạ và Từ điển hash.',
    worksOutOfBox: false,
    input: 'image',
  },
  {
    id: 'rotate',
    label: 'Xoay ảnh',
    taskType: 'RotateTask',
    solver: 'rotate',
    what: 'Xoay ảnh cho thẳng. Đáp án luôn là bội số của bước góc mà site chấp nhận.',
    needs: 'Cần model riêng cho kho ảnh của chính site đó. Xem training/README.md.',
    worksOutOfBox: false,
    input: 'image',
  },
];

export function typeInfo(id: NativeType): TypeInfo {
  return TYPE_INFO.find((t) => t.id === id) ?? TYPE_INFO[0]!;
}

/**
 * Sinh mot challenge Altcha HOP LE ngay trong trinh duyet.
 *
 * Vi sao can: `pow` la loai duy nhat khong can du lieu lan model, nen no la duong ngan
 * nhat de nguoi vua cai xong thay he thong that su lam duoc viec. Nhung no lai doi mot
 * challenge co that — ma capforge CO Y khong tu di lay ho (lam vay la mo mot duong SSRF
 * vao mang noi bo). Sinh o day thi vua co du lieu that, vua khong pha nguyen tac do.
 *
 * `challenge = sha256(salt + secret)`, dung cong thuc cua Altcha.
 */
export async function makeSampleAltchaChallenge(maxnumber = 60_000): Promise<{
  algorithm: string;
  salt: string;
  challenge: string;
  maxnumber: number;
  signature: string;
}> {
  const rand = new Uint8Array(8);
  crypto.getRandomValues(rand);
  const salt = Array.from(rand)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  // Dat bi mat o khoang giua de thoi gian giai la dai dien, khong phai truong hop de nhat.
  const secret = Math.floor(maxnumber * 0.35) + Math.floor(Math.random() * (maxnumber * 0.3));

  const bytes = new TextEncoder().encode(`${salt}${secret}`);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  const challenge = Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return {
    algorithm: 'SHA-256',
    salt,
    challenge,
    maxnumber,
    // Server that ky challenge de chong gia mao. O day khong co khoa ky, va solver
    // chep nguyen truong nay vao dap an chu khong kiem tra no — nen mot chuoi danh dau
    // ro rang la mau se that tha hon mot chu ky gia trong nhu that.
    signature: 'chu-ky-mau-tu-playground',
  };
}
